import React, { useEffect, useState } from 'react';
import { getCookie, clearQueryParams, getUserCases,  getExpireDate, getCurrentUser, getAppUser, getAppIntegration} from '../../functions/utils'; // Import the utility function
import {} from '../../functions/bestand';
import '../../css/ImportComponent.css';
import ImportHeaderComponent from '../page/ImportHeaderComponent';
import BestandLogo from '../../images/BestandLogo.png';
import { useTranslations  } from '../utilities/TranslationContext';

// Import the core library and icon packs you need
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faChevronDown, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Add the icons you will use to the library
library.add(faChevronDown, faXmark, faArrowLeft);

const BestandComponent = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const { getTranslation } = useTranslations();
  
  useEffect(() =>{
  },[]);

  useEffect(() =>{
    init();
  }, []); 

  async function init(){

  }

  return (
    <div className="import-container">
      <ImportHeaderComponent
        title="Bestand"
        logo={BestandLogo}
        subtitle={getTranslation('import_XeroSubtitle')}
      />
      <div className="import-component-container">
        <div className="import-component-content">
          <div className="import-content">
          </div>
        </div>
      </div>
    </div>
  );
}

export default BestandComponent;
